(() => {
  const controllers = new WeakMap();

  const init = root => {
    if (controllers.has(root)) return;
    const tabs = [...root.querySelectorAll('[data-care-tab]')];
    const panels = [...root.querySelectorAll('[data-care-panel]')];
    if (!tabs.length || tabs.length !== panels.length) return;
    const abort = new AbortController();
    const state = { abort, active: Math.min(Number(root.dataset.defaultTab) || 0, tabs.length - 1), run: 0 };
    controllers.set(root, state);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motion = root.dataset.panelMotion === 'true' && !reduced;

    const setState = index => {
      tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
    };

    const showInstant = index => {
      state.run += 1;
      panels.forEach((panel, panelIndex) => {
        panel.getAnimations().forEach(animation => animation.cancel());
        panel.hidden = panelIndex !== index;
        panel.style.removeProperty('opacity');
        panel.style.removeProperty('transform');
      });
      state.active = index;
      setState(index);
    };

    const activate = async (index, instant = false) => {
      if (index < 0 || index >= tabs.length) return;
      setState(index);
      if (index === state.active) return;
      const run = ++state.run;
      const previous = panels[state.active];
      const next = panels[index];
      state.active = index;
      previous.getAnimations().forEach(animation => animation.cancel());
      next.getAnimations().forEach(animation => animation.cancel());
      if (instant || !motion || !previous.animate) {
        previous.hidden = true;
        next.hidden = false;
        return;
      }
      try {
        await previous.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(20px)' }], { duration: 300, easing: 'cubic-bezier(.3,1,.3,1)', fill: 'forwards' }).finished;
      } catch (error) {}
      if (run !== state.run) return;
      previous.hidden = true;
      next.hidden = false;
      try {
        await next.animate([{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 300, easing: 'cubic-bezier(.3,1,.3,1)', fill: 'forwards' }).finished;
      } catch (error) {}
    };

    showInstant(state.active);
    root.classList.add('is-enhanced');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index), { signal: abort.signal });
      tab.addEventListener('keydown', event => {
        let target = index;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = tabs.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(index); return; }
        else return;
        event.preventDefault();
        tabs.forEach(item => { item.tabIndex = -1; });
        tabs[target].tabIndex = 0;
        tabs[target].focus();
        tabs[target].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
        if (root.dataset.activation === 'automatic') activate(target);
      }, { signal: abort.signal });
    });
    root._careActivate = activate;
  };

  const initialize = (scope = document) => scope.querySelectorAll('[data-care-tabs]').forEach(init);
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest?.('[data-care-tabs]');
    const tab = root?.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (!root || !tab) return;
    root._careActivate?.(Number(tab.dataset.index), true);
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-care-tabs]').forEach(root => {
    const state = controllers.get(root);
    state?.abort.abort();
    root.querySelectorAll('[data-care-panel]').forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
    controllers.delete(root);
  }));
})();
